import { useGtag } from "./useGtag.mjs";
export function useTrackEvent(...args) {
  const { gtag } = useGtag();
  gtag("event", ...args);
}
